import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import { Hidden, Modal, Typography } from "@insite/mobius/index";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import StoreIcon from "@NA/Icons/StoreIcon";

interface OwnProps {
    isLbProduct: Boolean;
}

type Props = OwnProps;
export interface LBStorePickupStyles {
    freeStorePickup?: InjectableCss;
}

export const lbStorePickupStyles: LBStorePickupStyles = {
    freeStorePickup: {
        css: css`
            user-select:none;
            display: flex;
            align-items: flex-start;
            margin-top: 10px;
            font-size: 12px;
            font-weight: 700;
            &.lbProduct{
                opacity: 0.4;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 11px; `,
                            css` font-size: 11px; `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            svg {
                margin-right: 5px;
                min-width: 16px;
            }
            span {
                font-size: 12px;
                font-weight: 700;
                color: ${ADIColors.darkBlue1};
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css` font-size: 11px; padding-top: 0.5px;`,
                        css` font-size: 11px; padding-top: 0.5px;`,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },

};


const styles = lbStorePickupStyles;
const LBStorePickup: FC<Props> = ({
    isLbProduct = false
}) => {
    const [minStoreHeight, setMinStoreHeight] = useState(15);
    useEffect(() => {
        const maxStoreHeight = getMaxProductHeight('[data-test-selector="freeStorePickup"]');
        setMinStoreHeight(maxStoreHeight);
    }, []);

    return (
        <>
            <StyledWrapper {...styles.freeStorePickup}
                className={isLbProduct ? 'lbProduct' : ''}
                data-test-selector="freeStorePickup"
                style={{ minHeight: `${minStoreHeight}px` }}
            >
                <StoreIcon />
                <StyledWrapper>
                    {isLbProduct ?
                        (<Typography>
                            {translate("Store Pickup is not available")}
                        </Typography>)
                        :
                        (<Typography>{
                            translate("Free Store Pickup")}
                        </Typography>)}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

export default LBStorePickup;